import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';
import Index from './Index.vue';

import AgentReportsIndex from './AgentReportsIndex.vue';
import InboxReportsIndex from './InboxReportsIndex.vue';
import TeamReportsIndex from './TeamReportsIndex.vue';
import LabelReportsIndex from './LabelReportsIndex.vue';

import AgentReportsShow from './AgentReportsShow.vue';
import InboxReportsShow from './InboxReportsShow.vue';
import TeamReportsShow from './TeamReportsShow.vue';
import LabelReportsShow from './LabelReportsShow.vue';

import AgentReports from './AgentReports.vue';
import InboxReports from './InboxReports.vue';
import LabelReports from './LabelReports.vue';
import TeamReports from './TeamReports.vue';

import CsatResponses from './CsatResponses.vue';
import BotReports from './BotReports.vue';
import LiveReports from './LiveReports.vue';
import SLAReports from './SLAReports.vue';

import IaOverviewReport from './ia/IaOverviewReport.vue';
import HandoffsReport from './ia/HandoffsReport.vue';
import AnalysesReport from './ia/AnalysesReport.vue';
import PerformanceReport from './ia/PerformanceReport.vue';
import ProposalsReport from './ia/ProposalsReport.vue';
import ResolutionReports from './ResolutionReports.vue';
import AiDashboard from './AiDashboard.vue';
import MessageDataReport from './MessageDataReport.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage'],
};

const oldReportRoutes = [
  {
    path: 'agent',
    name: 'agent_reports',
    meta,
    component: AgentReports,
  },
  {
    path: 'inboxes',
    name: 'inbox_reports',
    meta,
    component: InboxReports,
  },
  {
    path: 'label',
    name: 'label_reports',
    meta,
    component: LabelReports,
  },
  {
    path: 'teams',
    name: 'team_reports',
    meta,
    component: TeamReports,
  },
];

const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: AgentReportsIndex,
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: AgentReportsShow,
  },

  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: InboxReportsIndex,
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: InboxReportsShow,
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: TeamReportsIndex,
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: TeamReportsShow,
  },
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: LabelReportsIndex,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'account_overview_reports', params: to.params };
          },
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta,
          component: LiveReports,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta,
          component: Index,
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'sla',
          name: 'sla_reports',
          meta,
          component: SLAReports,
        },
        {
          path: 'csat',
          name: 'csat_reports',
          meta,
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta,
          component: BotReports,
        },
        {
          path: 'message-data',
          name: 'message_data_reports',
          meta: { permissions: ['administrator'] },
          component: MessageDataReport,
        },
        {
          path: 'ia-overview',
          name: 'ia_overview_reports',
          meta: { permissions: ['administrator', 'report_manage'] },
          component: IaOverviewReport,
        },
        {
          path: 'transbordos',
          name: 'ia_handoffs_reports',
          meta: { permissions: ['administrator', 'report_manage'] },
          component: HandoffsReport,
        },
        {
          path: 'analises',
          name: 'ia_analyses_reports',
          meta: { permissions: ['administrator', 'report_manage'] },
          component: AnalysesReport,
        },
        {
          path: 'performance',
          name: 'performance_reports',
          meta: { permissions: ['administrator', 'report_manage'] },
          component: PerformanceReport,
        },
        {
          path: 'proposals',
          name: 'proposals_reports',
          meta: { permissions: ['administrator', 'report_manage'] },
          component: ProposalsReport,
        },
        {
          path: 'resolutions',
          name: 'resolution_reports',
          meta: { permissions: ['administrator', 'report_manage'] },
          component: ResolutionReports,
        },
        {
          path: 'ai-dashboard',
          name: 'ai_dashboard_reports',
          meta: { permissions: ['administrator', 'report_manage'] },
          component: AiDashboard,
        },
      ],
    },
  ],
};
